import { render, staticRenderFns } from "./uploader-v.vue?vue&type=template&id=3a439258&"
import script from "./uploader-v.vue?vue&type=script&lang=js&"
export * from "./uploader-v.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports